module.exports = __webpack_public_path__ + "clickup-integration-2-92ec2c7be1d41f915b6f532f9de3b6b2.webp";